export default __webpack_public_path__ + "static/media/page14.d51cff4c.webp";